<template>
    <div>
        <form @submit.prevent="onReset" novalidate>
            <div class="md:w-6/12 px-2 mx-auto">
                <base-input v-model.trim="password"
                            :id-prefix="''"
                            name="password"
                            :validations="[{ condition: v$.password.required &&  v$.password.$error && password == '',text:'Bitte tragen Sie Ihr Passwort ein!'},{ condition: v$.password.minLength.$invalid &&  v$.password.$error ,text:'Mindestlänge 6 Zeichen'}]"
                            :type="'password'" label="default.password" required/>

                <base-input v-model.trim="confirmPassword"
                            :id-prefix="'login'"
                            name="password_confirm"
                            :validations="[{ condition: v$.confirmPassword.$error ,text:'Bitte wiederholen Sie Ihr Passwort!'}]"
                            ref="login-password"
                            :type="'password'" label="default.password_confirm" required/>
                <base-button type="submit" :loading="axiosCall">
                    senden
                </base-button>

            </div>
        </form>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {minLength, required, sameAs} from '@vuelidate/validators'
import {ref, computed, getCurrentInstance }from 'vue'
import {API} from "@/utils/api";
import {useRouter,useRoute} from "vue-router";


export default {

    setup(props) {

        const route = useRoute();
        const router = useRouter();
        const password = ref('');
        const confirmPassword = ref('');

        const axiosCall = ref(false);
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        const rules = computed(() => ({

            password: {
                required,
                minLength: minLength(6)
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs(password.value),
            }
        }))

        const v$ = useVuelidate(rules, {password, confirmPassword})

        const onReset = () => {

            v$.value.$touch()

            if (v$.value.$error) return

            axiosCall.value = true

            const resetData = {
                password: password.value,
                password_confirmation: confirmPassword.value,
                token: route.params.token
            }

            API.post('reset', resetData).then((resp) => {
                axiosCall.value = false
                emitter.emit("flash-message", {
                    text: resp.data.message,
                    type: 'success'
                })
                router.push('/login');

            }).catch(err => {
                axiosCall.value = false
                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })
            })

        }

        return {
            password,
            confirmPassword,
            onReset,
            v$,
            axiosCall
        }

    }
}
</script>
